import { render, staticRenderFns } from "./indexGx.vue?vue&type=template&id=3e4ba91e&scoped=true"
import script from "./indexGx.vue?vue&type=script&lang=js"
export * from "./indexGx.vue?vue&type=script&lang=js"
import style0 from "./indexGx.vue?vue&type=style&index=0&id=3e4ba91e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4ba91e",
  null
  
)

export default component.exports